import React from 'react';
import Header from '../components/Header/Header';
import config from '../../site-config';
import './index.scss';

export default class MainLayout extends React.Component {
  render() {
    const { children } = this.props;
    return (
      <div style={{ margin: '0 auto', padding: '0 0rem' }}>
        <Header config={config} />
        <div className="layout-wrapper">{children()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layouts/index.jsx